// extracted by mini-css-extract-plugin
module.exports = {"contextualViewWizard":"980px","pageContent":"Borrowers_pageContent__2GveY","emailViewContainer":"Borrowers_emailViewContainer__Jni2F"};